import { Component, Input, OnInit, OnChanges, ChangeDetectionStrategy, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core'
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: "feature-list",
    templateUrl: './feature-list.template.html',
    styleUrls: ['./feature-list.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class FeatureList {
    @Input() list: any;
    @Input() showHeader: boolean = true;
    @Input() marqueeItem : any;
    @Input() data : Array<any>;
    @ViewChild('marquee-cell') marqueeCell: ElementRef;

    private size: string = "md";

    getMarqueeItem(): any {
        return Array.from(this.list && this.list.data || []).shift();
    }

    getData(): Array<any> {
        let result = Array.from(this.list && this.list.data || []);
        return result.slice(1);
    };

    private subscription: any;
    public carouselConfig = {
        center: false,
        showBack: false,
        dim: false,
        spacing: 15
    };

    constructor(
        private coreEffects: CoreEffects,
        private route: ActivatedRoute,
        private cd: ChangeDetectorRef
    ) { }

    ngOnInit() {
        // let result = Array.from(this.list && this.list.data || []);
        // this.marqueeItem = result.shift();
        // this.data = result;
    }


    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/feature-list/feature-list/feature-list.component.ts